<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="author">Colin Payne is a postman from Bristol, where he has lived for most of his life. He has two children of a bothersome age and a partner whose age shall not be mentioned.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt2.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt3.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="c-heading ParaOverride-1">Copyright © Colin Payne 2024</p>
<p class="c-normal ParaOverride-1">The right of <span class="CharOverride-1">Colin Payne</span> to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p>
<p class="c-normal ParaOverride-1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<p class="c-normal ParaOverride-1">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="c-normal ParaOverride-1">A CIP catalogue record for this title is available from the British Library.</p>
<p class="c-normal">ISBN 9781035834259 (Paperback)</p>
<p class="c-normal">ISBN 9781035834266 (Hardback)</p>
<p class="c-normal ParaOverride-1">ISBN 9781035834273 (ePub e-book)</p>
<p class="c-normal ParaOverride-1">www.austinmacauley.com</p>
<p class="c-normal">First Published 2024</p>
<p class="c-normal">Austin Macauley Publishers Ltd®</p>
<p class="c-normal">1 Canada Square </p>
<p class="c-normal">Canary Wharf</p>
<p class="c-normal">London</p>
<p class="c-normal">E14 5AA</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="ded-next">To Lois, Poppy and Rosie,</p>
<p class="ded ParaOverride-1">Thank you.</p>
<p class="ded ParaOverride-2">And Tiggy Dog.</p>
<p class="ded">Mum, Dad, Christine, Dave and Kevin. All the Morrells – Rudy, Lou, Joan, Kevin, Ciaran and Ben. All my friends – Ryan, Steve, Carey, Rich and Moo. My work colleagues. Everybody on my postal duty around Totterdown who read this silly story and encouraged me to get it published.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer007">
<p class="book-text-next">Yawn and stretch the puppy did do when he awoke from his slumber,</p>
<p class="book-text">What to do today, the doggie did wonder.</p>
<p class="book-text">First, I’ll eat the food in my bowl</p>
<p class="book-text">Followed by digging a nice big hole!!!</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer009">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt7.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer010">
<p class="book-text-next">And then I think a little nap</p>
<p class="book-text">Preferably on someone’s lap.</p>
<p class="book-text">So up he got, but soon did stop, rather abrupt</p>
<p class="book-text">For from his gut, a strange noise did erupt!</p>
<p class="book-text">It was an enormous  rumble</p>
<p class="book-text">And a huge grumble</p>
<p class="book-text">That arose from his belly</p>
<p class="book-text">It made him wobble like a great big jelly</p>
<p class="book-text">It shook him to his very core</p>
<p class="book-text">The likes of which the pup had never felt before</p>
<p class="book-text">Up it came faster and faster</p>
<p class="book-text">Try to stop it he just couldn’t master,</p>
<p class="book-text">So out it came, a noise like no other</p>
<p class="book-text ParaOverride-2">Quickly followed by another and another.</p>
<p class="book-text"><span class="CharOverride-2">HICCUP! HICCUP! HICCUP!</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer012">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt9.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer013">
<p class="book-text-next">The puppy did freeze,</p>
<p class="book-text">What was he to do? Would somebody help him, please?</p>
<p class="book-text">He looked around</p>
<p class="book-text">But no one was found</p>
<p class="book-text ParaOverride-2">And still, those hiccups wouldn’t back down!!</p>
<p class="book-text ParaOverride-2"><span class="CharOverride-2">HICCUP! HICCUP! HICCUP!</span></p>
<p class="book-text">He hiccupped on the bed!!!</p>
<p class="book-text">He hiccupped on his head!!!</p>
<p class="book-text">He hiccupped on the floor!!!</p>
<p class="book-text">He even hiccupped out of the door!!!</p>
<p class="book-text">And when he finally thought that was that</p>
<p class="book-text">He hiccupped next to the neighbour’s cat!!!</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer015">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt11.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
<p class="book-text-next">The cat jumped in such a shock</p>
<p class="book-text">It landed on top of the grandfather clock!!!</p>
<p class="book-text">“Oh,” said the cat. “You silly, silly pup</p>
<p class="book-text">Can’t you get those hiccups to stop?”</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer018">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt13.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer019">
<p class="book-text-next">“No, I can’t,” hiccupped the dog</p>
<p class="book-text">Who bizarrely had hiccupped on top of a great big frog!!!</p>
<p class="book-text">And that’s no joke</p>
<p class="book-text">The frog did croak.</p>
<p class="book-text">The cat climbed down</p>
<p class="book-text">With a great big frown</p>
<p class="book-text">And said to the pup</p>
<p class="book-text">“If you want them to stop</p>
<p class="book-text">Drink from a cup</p>
<p class="book-text ParaOverride-2">Upside down, you must sup.”</p>
<p class="book-text"><span class="CharOverride-2">HICCUP! HICCUP! HICCUP!</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer021">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt15.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer022">
<p class="book-text-next">The dog did wonder</p>
<p class="book-text">To drink from under?</p>
<p class="book-text">That was a lot to ask</p>
<p class="book-text">Could he do such a task?</p>
<p class="book-text">A cup he had found</p>
<p class="book-text">Great big red and round</p>
<p class="book-text">So the best form of attack</p>
<p class="book-text">Was to lie on his back</p>
<p class="book-text">He crawled up to the mug</p>
<p class="book-text">Upside down like a slug</p>
<p class="book-text">And feeling quite smug</p>
<p class="book-text ParaOverride-2">He took a big glug</p>
<p class="book-text"><span class="CharOverride-2">HICCUP! HICCUP! HICCUP!</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer024">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt17.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer025">
<p class="book-text-next">The cup tipped up</p>
<p class="book-text">All over the pup</p>
<p class="book-text">All over his head, all over his fur</p>
<p class="book-text">What happened next was a bit of a blur</p>
<p class="book-text">He ran out of the house</p>
<p class="book-text">Tripped over a mouse</p>
<p class="book-text">Rolled down the hill</p>
<p class="book-text">And in a pile of mud, he finally came still!</p>
<p class="book-text">All was quiet; nothing was heard</p>
<p class="book-text">Had those blasted hiccups disappeared?</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer027">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt19.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer028">
<p class="book-text-next ParaOverride-2"><span class="CharOverride-2">HICCUP! HICCUP! HICCUP!</span></p>
<p class="book-text">Out from the mud, the puppy did crawl</p>
<p class="book-text">So upset he started to bawl</p>
<p class="book-text">“That cat was no help at all</p>
<p class="book-text">I think he played a joke on me, made me look small</p>
<p class="book-text">To stop these hiccups, I must on my own</p>
<p class="book-text">I’ll start by looking in that traffic cone.”</p>
<p class="book-text">He poked his head in bit by bit</p>
<p class="book-text">Oh my, what a tight fit!!</p>
<p class="book-text">Of all the rotten luck</p>
<p class="book-text">His silly head had only gotten stuck</p>
<p class="book-text">He shook it to the left; he shook it to the right</p>
<p class="book-text">He shook it so hard he almost took flight!!</p>
<p class="book-text">But try as he might</p>
<p class="book-text">That cone was stuck tight!</p>
<p class="book-text">Probably for the rest of the night</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt21.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer031">
<p class="book-text-next ParaOverride-2"><span class="CharOverride-2">HICCUP! HICCUP! HICCUP!</span></p>
<p class="book-text">Oh, finally, some luck</p>
<p class="book-text">The cone had come unstuck</p>
<p class="book-text">He had hiccupped himself free</p>
<p class="book-text">And landed up a tree</p>
<p class="book-text">Down he climbed in one big mess</p>
<p class="book-text">How he liked these hiccups less and less</p>
<p class="book-text">All covered in mud, twigs, leaves and brambles</p>
<p class="book-text">He headed back home in a bit of a shambles</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer033">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt23.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer034">
<p class="book-text-next">No more for me; enough is enough</p>
<p class="book-text">If these hiccups don’t go, well, that’s just tough!</p>
<p class="book-text">As he walked up to his bed</p>
<p class="book-text">He had a feeling of dread!!</p>
<p class="book-text">For he caught a glimpse of something in the mirror</p>
<p class="book-text">The pup edged towards it, ever nearer and nearer</p>
<p class="book-text">Not sure what he’d see</p>
<p class="book-text">Not sure what it would be</p>
<p class="book-text">Oh my, what a sight!</p>
<p class="book-text">It gave the puppy a massive fright</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer036">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt25.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer037">
<p class="book-text-next">He ran away and dived under his cover</p>
<p class="book-text">Shaking all over, wondering if he’d ever recover</p>
<p class="book-text">The pup poked his head out</p>
<p class="book-text">But no one was about</p>
<p class="book-text">He looked around</p>
<p class="book-text">Nobody, nothing, not even a sound</p>
<p class="book-text">Not even a hiccup</p>
<p class="book-text">Not even a <span class="CharOverride-2">HICCUP!</span></p>
<p class="book-text">Not even a <span class="CharOverride-2">HICCUP!</span></p>
<p class="book-text">Oh finally! At long last, the hiccups had gone, and he was a very, very happy puppy.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer039">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035834259_txt27.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
<p class="last">AITCHOO!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-2.vue?191f45e4